import config, { Environment } from '../config/config'

/**
 * DMVP-1010: When true, the post-survey appears BEFORE the certificate page (new flow).
 * When false, the post-survey appears AFTER the certificate page (old flow).
 *
 * Enabled in non-PROD environments (and the 'test' production account).
 * Feature flagged in PROD until a congratulations page is added after the Lightning Round.
 *
 * To remove this feature flag, replace all usages with `true` and delete this file.
 */
export const isSurveyBeforeCertEnabled = (): boolean =>
  config.environment !== Environment.PRODUCTION || config.getAccountSlug() === 'test'
